/**
 * @author lifei & gll
 * 模块说明：xxx
 */

import { Service } from '@/tools'
export class ScrapNoticeService <T extends TStock.ScrapNotice> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TStock.ScrapNotice}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }
            
  /**
   * 功能：编辑报废通知单
   */
  update = (data: T['ApiUpdate']['req']): Promise<T['ApiUpdate']['res']> => this.post2('v1/ApiUpdate', data)
            
  /**
   * 功能：分页查询报废商品池
   */
  skuPoolPageList = (data: T['ApiSkuPoolPageList']['req']): Promise<T['ApiSkuPoolPageList']['res']> => this.post2('v1/ApiSkuPoolPageList', data)
            
  /**
   * 功能：商品报废
   */
  scrapped = (data: T['ApiScrapped']['req']): Promise<T['ApiScrapped']['res']> => this.post2('v1/ApiScrapped', data)
            
  /**
   * 功能：分页报废通知单
   */
  page = (data: T['ApiPage']['req']): Promise<T['ApiPage']['res']> => this.post2('v1/ApiPage', data)
            
  /**
   * 功能：分页查询连锁店报废数据
   */
  pageListReportData = (data: T['ApiPageListReportData']['req']): Promise<T['ApiPageListReportData']['res']> => this.post2('v1/ApiPageListReportData', data)
            
  /**
   * 功能：商品解除报废
   */
  lift = (data: T['ApiLift']['req']): Promise<T['ApiLift']['res']> => this.post2('v1/ApiLift', data)
            
  /**
   * 功能：报废通知单详情
   */
  detail = (data: T['ApiDetail']['req']): Promise<T['ApiDetail']['res']> => this.post2('v1/ApiDetail', data)
            
  /**
   * 功能：删除报废通知单
   */
  delete = (data: T['ApiDelete']['req']): Promise<T['ApiDelete']['res']> => this.post2('v1/ApiDelete', data)
            
  /**
   * 功能：取消报废通知单
   */
  cancel = (data: T['ApiCancel']['req']): Promise<T['ApiCancel']['res']> => this.post2('v1/ApiCancel', data)
            
  /**
   * 功能：创建报废通知单
   */
  add = (data: T['ApiAdd']['req']): Promise<T['ApiAdd']['res']> => this.post2('v1/ApiAdd', data)
}
